import { Users } from "lucide-react";
import { Button } from "@/core/components/ui/button";
import { Stack } from "@/core/components/ui/stack";
import { Typography } from "@/core/components/ui/typography";

interface RecipientEmptyStateProps {
  searchValue: string;
  onClearSearch: () => void;
  hasTeamFilter?: boolean;
  onClearTeams?: () => void;
}

export const RecipientEmptyState = ({
  searchValue,
  onClearSearch,
  hasTeamFilter = false,
  onClearTeams,
}: RecipientEmptyStateProps) => {
  const hasSearch = searchValue.trim().length > 0;

  return (
    <Stack
      align="center"
      justify="center"
      gap="sm"
      fullWidth
      className="min-h-0 flex-1 px-6 py-16 text-center"
    >
      <Users className="size-10 text-tertiary-text" strokeWidth={1.5} />
      <Stack gap="xs" align="center">
        <Typography variant="subtitleW2">
          {hasSearch
            ? "No technicians match your search"
            : hasTeamFilter
              ? "No technicians match the selected teams"
              : "No technicians found"}
        </Typography>
        <Typography variant="bodyW3" textColor="secondary">
          {hasSearch
            ? "Try a different technician name."
            : hasTeamFilter
              ? "Select different teams or clear the team filter."
              : "Technicians with ServiceTitan IDs will show up here."}
        </Typography>
      </Stack>
      {hasTeamFilter && (
        <Button
          type="button"
          size="sm"
          variant="secondary"
          onClick={onClearTeams}
        >
          Clear teams
        </Button>
      )}
      {hasSearch && (
        <Button
          type="button"
          size="sm"
          variant="secondary"
          onClick={onClearSearch}
        >
          Clear search
        </Button>
      )}
    </Stack>
  );
};
